require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journes-portes-ouvertes-0-7-3-2.json") })
        }
      }, "path---journes-portes-ouvertes-0-7-3-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journes-portes-ouvertes-0-7-3-2!./.cache/json/journes-portes-ouvertes-0-7-3-2.json
// module id = 470
// module chunks = 231608221292675